module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nny-d667cbc59729ea0cfac76d18b33ae3ee.png";